import CallService from "@/src/api/CallService.js";
import { setCallSetting } from "@/src/utils/callsUtils.js";
import { callSettingKeys, settingValues } from "@/src/constants/callConstants.js";

export default {
  namespaced: true,

  state: {
    settings: {
      [callSettingKeys.RECORD_CALL]: false,
      [callSettingKeys.AUTO_MACHINE_DETECTION]: false,
      [callSettingKeys.CALL_TRANSCRIPT]: false,
      [callSettingKeys.DISPOSITION_MANDATORY]: false,
      [callSettingKeys.POST_CALL_FORM_AUTO_OPEN]: false,
    },
    isLoading: false,
  },

  mutations: {
    SET_DIALER_SETTINGS(state, settings) {
      state.settings = { ...state.settings, ...settings };
    },
    SET_SINGLE_SETTING(state, { key, value }) {
      state.settings[key] = value;
    },
    SET_LOADING(state, value) {
      state.isLoading = value;
    },
  },

  actions: {
    async fetchDialerSettings({ commit }) {
      try {
        commit("SET_LOADING", true);
        const response = await CallService.getDialerSettings();

        if (!response?.success) {
          throw new Error(response?.error || "Failed to fetch dialer settings");
        }

        if (response.settings) {
          const mappedSettings = {};
          Object.keys(response.settings).forEach((key) => {
            mappedSettings[key] = response.settings[key] === settingValues.TRUE;
          });
          commit("SET_DIALER_SETTINGS", mappedSettings);
        }
      } catch (error) {
        console.error("Error fetching dialer settings:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateSetting({ commit }, { key, value }) {
      try {
        if (!key) {
          console.error("Setting key is required");
          return { success: false };
        }

        const success = await setCallSetting(key, value);

        if (success) {
          commit("SET_SINGLE_SETTING", { key, value });
          return { success: true };
        } else {
          console.error("Failed to update setting");
          return { success: false };
        }
      } catch (error) {
        console.error("Error updating setting:", error);
        return { success: false, error };
      }
    },
  },

  getters: {
    isGlobalRecordingEnabled: (state) => state.settings[callSettingKeys.RECORD_CALL],
    isAutoMachineDetectionEnabled: (state) => state.settings[callSettingKeys.AUTO_MACHINE_DETECTION],
    isCallTranscriptEnabled: (state) => state.settings[callSettingKeys.CALL_TRANSCRIPT],
    isDispositionMandatory: (state) => state.settings[callSettingKeys.DISPOSITION_MANDATORY],
    isPostCallFormAutoOpenEnabled: (state) => state.settings[callSettingKeys.POST_CALL_FORM_AUTO_OPEN],
    allSettings: (state) => state.settings,
    isLoading: (state) => state.isLoading,
  },
};
